<template>
    <div class="archive">
        <div class="container">
            <h1 class="title title--uppercase archive__title">{{ $lang('archive.title') }}</h1>
            <archive-status class="archive__status" />
            <archive-pages class="archive__pages" />
        </div>
    </div>
</template>

<script>
import ArchiveStatus from "./ArchiveStatus.vue";
import ArchivePages from "./ArchivePages.vue";
import {mapActions, mapMutations} from "vuex";

export default {
    name: 'Archive',
    components: {
        ArchivePages,
        ArchiveStatus,
    },
    props: {
        statusId: {
            type: Number,
            default: null,
        },
    },
    mounted() {
        this.setHistoricalStatusId(this.statusId);
        this.getPages();
    },
    methods: {
        ...mapMutations('archive', [
            'setHistoricalStatusId',
        ]),
        ...mapActions('archive', [
            'getPages',
        ]),
    },
}
</script>

<style lang="scss" scoped>
.archive {
    padding: 58px 0 110px;
}
.archive__status {
    margin-top: 48px;
}
.archive__pages {
    margin-top: 48px;
}
</style>
